/**
 * Convert a hex color to rgba with the provided opacity.
 * Supports 6 or 8 character hex values (alpha in input is ignored in favor of provided opacity).
 */
export function hexToRgba(hex: string, opacity: number): string {
  const cleanHex = hex.replace('#', '');
  const hexColor = cleanHex.length === 8 ? cleanHex.slice(0, 6) : cleanHex;

  if (hexColor.length !== 6) return hex;

  const r = parseInt(hexColor.slice(0, 2), 16);
  const g = parseInt(hexColor.slice(2, 4), 16);
  const b = parseInt(hexColor.slice(4, 6), 16);

  if ([r, g, b].some(channel => Number.isNaN(channel))) return hex;

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
